import React, { ComponentProps } from "react";

import NoteTagsDisplay from "../../../CustomerNotes/Components/NoteTagsDisplay";
import { SeriesNoteTagsBuilder } from "../../../CustomerNotes/Types/NoteTagsConfiguration";
import SeriesSeparatorNoteTagsContentBuilder from "../../../CustomerNotes/Types/SeriesSeparatorNoteTagsContentBuilder";
import ContextValueProvider from "../../../Providers/Value/ContextValueProvider";
import AppointmentNoteCard, {
  IAppointmentNoteCardProps,
  IAppointmentNoteFieldProps
} from "../Components/AppointmentNoteCard";
import AppointmentNoteField from "../Components/AppointmentNoteField";
import AppointmentNoteTagsConfig, { AppointmentNoteTagsProps } from "./AppointmentNoteTags";

const ConfiguredAppointmentNoteField: React.FC<IAppointmentNoteFieldProps> = props => (
  <AppointmentNoteField noteCharacterLimit={1024} {...props} />
);

const noteTagContentBuilder = new SeriesSeparatorNoteTagsContentBuilder(" / ");
const appointmentNoteTagConfig = new SeriesNoteTagsBuilder<AppointmentNoteTagsProps>(AppointmentNoteTagsConfig);

const ConfiguredAppointmentNoteCard: React.FC<IAppointmentNoteCardProps<AppointmentNoteTagsProps>> = props => (
  <AppointmentNoteCard
    CustomNoteField={ConfiguredAppointmentNoteField}
    NoteTags={NoteTagsDisplay}
    noteTagContentBuilder={noteTagContentBuilder}
    noteTagConfig={appointmentNoteTagConfig}
    {...props}
  />
);

const ComposedAppointmentNoteCard: React.FC<Omit<IAppointmentNoteCardProps<AppointmentNoteTagsProps>, "noteTagProps">> =
  ContextValueProvider<
    Pick<IAppointmentNoteCardProps<AppointmentNoteTagsProps>, "noteTagProps">,
    ComponentProps<typeof ConfiguredAppointmentNoteCard>
  >({
    Component: ConfiguredAppointmentNoteCard,
    map: ({
      appointment,
      customer,
      ignoreNonCan,
      lead,
      leadDisqualifiers,
      medicalConclusions,
      note: { text },
      user
    }) => ({
      noteTagProps: { appointment, customer, ignoreNonCan, lead, leadDisqualifiers, medicalConclusions, user },
      value: text || "",
      disabled: false
    })
  });

export default ComposedAppointmentNoteCard;
